import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'
import { InternalExternalLink } from '../../types/InternalExternalLink'
import { LinkSection, LinkSubsection } from '../../types/LinkSection'
import { isNullOrWhiteSpace } from '../../utilities/string'
import { Chevron } from '../Chevron'
import { FooterLink } from './FooterLink'

export interface FooterLinkBoxProps {
  linkSection: LinkSection
  collapsed?: boolean
}

const SingleItem = ({
  children,
  customAttributes,
  isExternal,
  title,
  url,
}: PropsWithChildren<InternalExternalLink>) => (
  <li className="my-5 font-footer-link text-footer-link">
    <FooterLink url={url} customAttributes={customAttributes} isExternal={isExternal}>
      {children ?? title}
    </FooterLink>
  </li>
)

const Subsection = ({ links, title }: LinkSubsection) => (
  <li className="mt-15 font-footer-subtitle text-footer-subtitle tb:mt-30 first:mt-5">
    <h3>{title}</h3>

    <ul>
      {links?.map((subitem, index) => (
        <SingleItem {...subitem} key={index}>
          {subitem.title}
        </SingleItem>
      ))}
    </ul>
  </li>
)

export const FooterLinkBox = ({
  linkSection: rootNode,
  collapsed = false,
}: FooterLinkBoxProps): JSX.Element => (
  <div
    className={classNames('last:mb-0 text-secondary-darker', {
      'mb-30': !collapsed,
    })}
  >
    <h2
      className={classNames(
        'font-footer-title text-footer-title py-7 whitespace-nowrap',
        'tb:pt-0 tb:pb-4'
      )}
    >
      <FooterLink url={rootNode.url}>
        {rootNode.title}

        {!isNullOrWhiteSpace(rootNode.url) && (
          <Chevron
            additionalClassName="ml-7 mb-2"
            direction="right"
            width="w-7"
            height="h-7"
            // Remove the default duration from transitionClassName, otherwise Chrome queues up the animations, resulting
            // in the chevron changing color after the text.
            transitionClassName=""
          />
        )}
      </FooterLink>
    </h2>

    {!collapsed && (
      <ul>
        {rootNode.subitems?.map((item, index) => {
          if ('links' in item) {
            return <Subsection {...item} key={index} />
          } else {
            return (
              <SingleItem {...item} key={index}>
                {item.title}
              </SingleItem>
            )
          }
        })}
      </ul>
    )}
  </div>
)
